export const SOCIAL_MEDIA = [
   {
      platform: 'telegram',
      handle: '',
   },
   {
      platform: 'twitter',
      handle: '',
   },
   {
      platform: 'github',
      handle: '',
   },
   {
      platform: 'medium',
      handle: '',
   },
   {
      platform: 'gitbook',
      handle: '',
   },
   {
      platform: 'reddit',
      handle: '',
   },
]
